import React from "react";

export const PreviewValue: React.FC<{ size: number; value: any; }> = ({ }) => {
    return <span className="jv-preview"> ... </span>;
};
